module.exports = __webpack_public_path__ + "img/awards_image_22.af1ad8b4.jpg";